import { useFragment } from 'react-relay';

import { getFragment } from '../store-fragment';
import { StoreFragmentType } from '../types';
import { KeyType } from 'react-relay/relay-hooks/helpers';

export const useFragmentFromStore = <T extends KeyType,>(fragmentRef: any) => {
    const fragments = fragmentRef?.__fragments;

    const [listNameOfFragments] = Object.keys(fragments || {}) as (keyof StoreFragmentType)[];

    return useFragment<T>(getFragment(listNameOfFragments || 'pageTableInfoFragment'), fragmentRef);
};
